const DATE_TIME_INPUT_FORMAT = 'DD/MM/YYYY à HH:mm'
const DATE_INPUT_FORMAT = 'DD/MM/YYYY'

export class CustomDateFormat {
    onlyDate:boolean = false;

    get parse() {
        return {
            dateInput: this.onlyDate? DATE_INPUT_FORMAT : DATE_TIME_INPUT_FORMAT,
        }
    }

    get display() {
        return {
            dateInput: this.onlyDate? DATE_INPUT_FORMAT : DATE_TIME_INPUT_FORMAT,
            monthYearLabel: 'MMM YYYY',
            dateA11yLabel: 'LL',
            monthYearA11yLabel: 'MMMM YYYY',
            enableMeridian: true
        }
    }
}